import showNotification from '@shoflo/studio-redux/actions/notification/showNotification';
import setSourceUploadStatus from '@shoflo/studio-redux/actions/source/setSourceUploadStatus';
import { FAILED } from 'constants/SourceUploadStatus';

export default (dispatch, fileName) => () => {
  dispatch(setSourceUploadStatus(fileName, FAILED));
  return dispatch(
    showNotification('Upload Failed', {
      type: 'warning'
    })
  );
};
